export const ENV = {
    PRODUCTION_ENV: 'production',
    STAGING_ENV: 'staging',
    CI_ENV: 'ci',
};

export const isEnvPresent = () => window.ENV && !window.ENV.startsWith('{creds');
